import React from "react";
import { connect } from "react-redux";
import { PageTabs } from "../../../../../../store/AppDisplays";
import { Filter } from "../../../02-pages/Filter";
import { isRemoteLoading, ReduxState } from "../../../../../../store/ReduxState";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { Results } from "../../../02-pages/Results";
import { Payments as PaymentType } from "../../../../../../store/PartnerPayments/Types";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";

interface OwnProps {
    partnerId: string;
}

/**
 *
 */
interface StateProps {
    loadingFilters: boolean;
    loadingResults: boolean;
    results: PaymentType;
}

type Props = OwnProps & StateProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    loadingFilters: false,
    loadingResults: isRemoteLoading(s, RemoteScope.PAYMENT_RESULTS),
    results:
            s.prop("remote").prop(RemoteScope.PAYMENT_RESULTS),
});

/**
 *
 * @param props
 */
export class PaymentsComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
    }

    public render() {
        return (
            <Div style={{ marginTop: "-20px" }}>
                <Filter
                    loadingFilters={this.props.loadingFilters}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.PARTNER_PAYMENTS}
                    defaultFilters={{
                        partnerId: this.props.partnerId,
                    }}
                />
                <Results
                    results={this.props.results}
                    loadingResults={this.props.loadingResults}
                    currentPage={PageTabs.PARTNER_PAYMENTS}
                    scope={RemoteScope.PAYMENT_RESULTS}
                />
            </Div>
        );
    }
}

/**
 *
 */
export const Payments = connect(
    mapStateToProps,
    {},
)(PaymentsComp);
